import { render, staticRenderFns } from "./phoneQuestionFileNew.vue?vue&type=template&id=d15e8eec"
import script from "./phoneQuestionFileNew.vue?vue&type=script&lang=js"
export * from "./phoneQuestionFileNew.vue?vue&type=script&lang=js"
import style0 from "./phoneQuestionFileNew.vue?vue&type=style&index=0&id=d15e8eec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports